import { base_colorAction } from 'ext-ui/style/colors'
import React, { SVGProps } from 'react'

const SvgSidenavExpenseCategoriesActive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M7.25574 0.749939C7.5869 0.749939 7.87517 0.74547 8.15417 0.812439C8.38358 0.86756 8.6034 0.958704 8.80457 1.08197C9.04899 1.23186 9.24928 1.43879 9.48328 1.67279L15.2343 7.42377C15.671 7.8605 16.0316 8.22033 16.2997 8.53607C16.5732 8.85836 16.7946 9.18486 16.9208 9.57318C17.1165 10.1756 17.1165 10.8243 16.9208 11.4267C16.7946 11.815 16.5732 12.1415 16.2997 12.4638C16.0316 12.7796 15.671 13.1393 15.2343 13.5761L13.576 15.2343C13.1393 15.6711 12.7795 16.0317 12.4637 16.2997C12.1414 16.5733 11.815 16.7947 11.4266 16.9208C10.8242 17.1165 10.1755 17.1165 9.57312 16.9208C9.1848 16.7946 8.8583 16.5733 8.53601 16.2997C8.22027 16.0317 7.86044 15.6711 7.42371 15.2343L1.67273 9.48334C1.43873 9.24934 1.2318 9.04905 1.08191 8.80463C0.958643 8.60346 0.867499 8.38364 0.812378 8.15424C0.745409 7.87523 0.749878 7.58696 0.749878 7.2558V5.11908C0.749877 4.78792 0.745394 4.49965 0.812378 4.22064C0.867507 3.99123 0.958628 3.77143 1.08191 3.57025C1.23182 3.32582 1.43871 3.12556 1.67273 2.89154L2.89148 1.67279C3.1255 1.43877 3.32575 1.23188 3.57019 1.08197C3.77137 0.958689 3.99117 0.867568 4.22058 0.812439C4.49959 0.745455 4.78786 0.749938 5.11902 0.749939H7.25574ZM5.99988 4.87494C5.37861 4.87497 4.87491 5.37867 4.87488 5.99994C4.87488 6.62124 5.37859 7.12491 5.99988 7.12494C6.6212 7.12494 7.12488 6.62126 7.12488 5.99994C7.12484 5.37865 6.62118 4.87494 5.99988 4.87494Z"
      fill={props.fill || base_colorAction}
    />
  </svg>
)
export default SvgSidenavExpenseCategoriesActive
